import styles from './SPIDButton.module.scss';
import { Icon, IconsEnum } from 'components/Icons';
import { useMemo, useRef, useState } from 'react';
import { isTruthy } from 'utility/functions';

import { SpidEntityType, SpidGovEntities, titillium } from './types';
import { PROVENIENCE_QUERY_PARAM } from 'utility/constant';
import classNames from 'classnames';
import React from 'react';
import { useClickAway } from 'hooks/useClickAway';
import Persist, { StorageKind } from 'lib/persist';
import { setExtraData } from 'features/signup/signup';
import { useAppDispatch } from 'lib/centralStore';

export interface SPIDButtonProps {
  onClick: (redirectUrl: string) => void;
}

export const SPIDButton = ({ onClick }: SPIDButtonProps) => {
  const [toggle, setToggle] = useState(false);

  const dispatch = useAppDispatch();

  const refMe = useRef<HTMLAnchorElement>(null);
  const refWrapper = useRef<HTMLDivElement>(null);

  const isTestEnv = isTruthy(process.env.NEXT_PUBLIC_IS_TEST_ENV);

  const testProvider: SpidEntityType = {
    entity_id: 'DEMO',
    organization_name: 'Demo',
  };

  const locationQuery = useMemo(() => new URLSearchParams(window.location.search), []);

  const shufled = useMemo(() => {
    return SpidGovEntities.map((x) => ({ ...x, seq: Math.random() })).sort((a, b) => (a.seq > b.seq ? 1 : -1));
  }, []);

  const onEntityClickHandler = (ev: React.MouseEvent<HTMLAnchorElement, MouseEvent>, organization_name: string) => {
    ev.stopPropagation();
    ev.preventDefault();

    setToggle(false);

    const url = `https://spid.snai.it/spid-bridge.php?idp=${encodeURIComponent(
      organization_name
    )}&mobile=0&${PROVENIENCE_QUERY_PARAM}=snaiit_sport&referer=${encodeURIComponent(window.location.origin)}`;

    onClick(url);

    Persist(StorageKind.session).setItem('btag', locationQuery.get('btag') || '');
    Persist(StorageKind.session).setItem(PROVENIENCE_QUERY_PARAM, locationQuery.get(PROVENIENCE_QUERY_PARAM) || '');

    dispatch(
      setExtraData({
        btag: Persist(StorageKind.session).getItem('btag') || '',
        provenienceCode: Persist(StorageKind.session).getItem('btag') || '',
      })
    );
  };

  const onToggle = () => {
    setToggle((prev) => (prev ? false : true));
  };

  useClickAway({ refElement: refWrapper, onClickAway: () => setToggle(false) });

  return (
    <div ref={refWrapper}>
      <a onClickCapture={onToggle} ref={refMe} className={classNames(styles.button, titillium.className)}>
        <Icon iconId={IconsEnum.SPID_LOGO} className={styles.icon} />
        <span className={styles.main}>Entra con SPID</span>
      </a>
      {toggle && (
        <div className={styles['list-wrapper']}>
          <ul className={styles.list}>
            {shufled.map(({ organization_name, logo_uri, entity_id }: SpidEntityType) => (
              <li title={organization_name} className={styles.row} key={entity_id}>
                <a
                  href={`${entity_id}`}
                  className={styles.organization}
                  onClickCapture={(ev) => onEntityClickHandler(ev, organization_name)}
                >
                  {logo_uri ? (
                    <img src={logo_uri} alt={organization_name} className={styles['organization-name']} />
                  ) : (
                    <span className={styles['organization-name']}>organization_name</span>
                  )}
                </a>
              </li>
            ))}
            {isTestEnv && (
              <li title={testProvider.organization_name} className={styles.row}>
                <a
                  href={`${window.location.origin}/spid-bridge/${testProvider.organization_name}`}
                  className={styles.organization}
                  onClickCapture={(ev) => onEntityClickHandler(ev, testProvider.entity_id)}
                >
                  <span className={styles['organization-name']}>{testProvider.organization_name}</span>
                </a>
              </li>
            )}
          </ul>
          <ul>
            <li title={'Maggiori Info'} className={styles.row}>
              <a className={styles.organization} href="https://www.spid.gov.it" target="_blank">
                <span className={styles['organization-name']}>Maggiori Info</span>
              </a>
            </li>
            <li title={'Non hai SPID?'} className={styles.row}>
              <a
                className={styles.organization}
                href="https://www.spid.gov.it/cos-e-spid/come-attivare-spid"
                target="_blank"
              >
                <span className={styles['organization-name']}>Non hai SPID?</span>
              </a>
            </li>
          </ul>
        </div>
      )}
    </div>
  );
};
